












































































































































































































































































































































































































import Vue from 'vue';
import {Component} from "vue-property-decorator";

@Component({
    components: {}
})
export default class FicheC extends Vue {

}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FicheC.vue